import { ArticlesFilters as Filters } from "src/components/NewComponents/Creator/Filters/ArticlesFilters";
import { useGetArticlesCategories } from "src/hooks/useArticles";

type ArticlesFiltersProps = {
	details: Record<string, unknown>;
	setDetails: (details: Record<string, unknown>) => void;
};

export function ArticlesFilters({ details, setDetails }: ArticlesFiltersProps) {
	const { isLoading, data: departments } = useGetArticlesCategories();

	return (
		<Filters
			details={details}
			setData={setDetails}
			departments={departments}
			isLoading={isLoading}
		/>
	);
}
